import { Tooltip } from 'canoe';
import React from 'react';

import { COPYTEXT } from '@candu-ai/styleguide/selectors';

export const RichTextCopy = () => {
  return (
    <Tooltip content="Users can click here to copy the text" placement="right" offset="xs">
      <button
        disabled
        className={`${COPYTEXT.Wrapper} candu-img-button`}
        type="button"
        aria-label="Copy"
        style={{ cursor: 'default' }}
      >
        <svg
          aria-hidden="true"
          className={`${COPYTEXT.SVG}`}
          width="16px"
          height="16px"
          viewBox="0 0 20 20"
          fill="inherit"
          stroke="none"
          version="1.1"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 1.5h12a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5ZM4 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2ZM2.75 4a.75.75 0 0 0-1.5 0v12A2.75 2.75 0 0 0 4 18.75h12a.75.75 0 0 0 0-1.5H4c-.69 0-1.25-.56-1.25-1.25V4Z"
            fill="inherit"
          />
        </svg>
      </button>
    </Tooltip>
  );
};
